import type { JSX } from "react";
import { Flex, Image, Text } from "@aws-amplify/ui-react";

import uploadIconUrl from "@assets/buttons/upload.png";
import { DROP_ZONE_PROMPT } from "./messages";

type UploadDropZoneProperties = {
  /** Opens the file dialogue; dropping is handled by the drop zone around this. */
  readonly onBrowse: () => void;
  /** What the folder accepts, as one line of guidance. */
  readonly formatsLabel: string;
};

/**
 * The card that invites an upload, shown in an empty upload folder.
 */
export function UploadDropZone({
  onBrowse,
  formatsLabel,
}: UploadDropZoneProperties): JSX.Element {
  return (
    <Flex alignItems="center" flex="1" justifyContent="center" padding="1.5rem">
      <button
        className="evido-upload-drop-zone"
        onClick={onBrowse}
        type="button"
      >
        <Image alt="" aria-hidden="true" src={uploadIconUrl} width="2rem" />
        <Text as="span" className="evido-upload-drop-zone__prompt">
          {DROP_ZONE_PROMPT}
        </Text>
        <Text as="span" className="evido-upload-drop-zone__formats">
          {formatsLabel}
        </Text>
      </button>
    </Flex>
  );
}
